export const DefaultPremiums = 'Calculator/CalculateDefaults';
export const CalculatePremiums = 'Calculator/Calculate';

export const NetBenefitEstimate = 'BenefitEstimator/Estimate';
export const HistoricAnalysis = 'HistoricAnalysis/Get';
export const MilkPriceAnalysis = 'CoverageAnalysis/Get';
